export const STOREFRONT_TYPES = {
  EKS: 'eks',
  NETLIFY: 'netlify',
  CLOUDFLARE: 'cloudflare',
};

export const isStoreSFV4 = deploymentLocation =>
  deploymentLocation && deploymentLocation !== STOREFRONT_TYPES.CLOUDFLARE;
